import { environment } from 'environments/environment';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    identificador?: string;
    ambiente?: string;
    a11y?: {
      watch?: (path?: string) => void;
    };
    __a11yInitialized?: boolean;
  }
}

const SCRIPT_SRC = 'https://cdn-scorea11y.estaleiro.serpro.gov.br/a11y-tracking.js';

const useA11yTracking = (): void => {
  const location = useLocation();

  const isDesenvolvimento = environment.environment === 'des' || environment.environment === 'local';

  useEffect(() => {
    if (!isDesenvolvimento) return;

    if (!window.__a11yInitialized) {
      window.identificador = process.env.REACT_APP_SIGLA_PROJETO ?? 'PGRM';
      window.ambiente = (process.env.REACT_APP_AMBIENTE ?? 'desenvolvimento').toLowerCase();

      addScript(SCRIPT_SRC);
      window.__a11yInitialized = true;
    }
  }, []);

  useEffect(() => {
    if (!isDesenvolvimento) return;

    if (window.a11y?.watch) {
      console.log('A11Y watch disparado:', location.pathname);

      window.a11y.watch(location.pathname);
    }
  }, [location.pathname]);

  const addScript = (src: string): void => {
    if (document.querySelector(`script[src="${src}"]`)) return;

    const script = document.createElement('script');
    script.src = src;
    script.async = false;

    document.body.appendChild(script);
  };
};

export default useA11yTracking;
